import { __awaiter } from "tslib";
export class Renderer {
    constructor(rootElement) {
        this.rootElement = rootElement;
    }
    render(microfrontend) {
        if (typeof microfrontend === 'function') {
            this.renderLazyMicrofrontend(microfrontend);
            return;
        }
        this.renderMicrofrontend(microfrontend);
    }
    getRootElement() {
        return this.rootElement;
    }
    unmountCurrentMicrofrontend() {
        if (this.currentMicrofrontend) {
            this.currentMicrofrontend.unmount(this.rootElement);
        }
    }
    renderLazyMicrofrontend(lazyMicrofrontend) {
        return __awaiter(this, void 0, void 0, function* () {
            const microfrontend = yield this.getLazyMicrofrontend(lazyMicrofrontend);
            this.renderMicrofrontend(microfrontend);
        });
    }
    renderMicrofrontend(microfrontend) {
        this.unmountCurrentMicrofrontend();
        microfrontend.mount(this.rootElement, {});
        this.currentMicrofrontend = microfrontend;
    }
    getLazyMicrofrontend(lazyMicrofrontend) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield lazyMicrofrontend().then((microfrontendModule) => microfrontendModule.default);
        });
    }
}
